<template>
  <div>
    <Nav></Nav>
    
    <!-- Report Card -->
    <b-card class="mb-3">
      <b-card-title>Reporte de Facturación</b-card-title>
      <b-row>
        <b-col md="3">
          <b-card bg-variant="light" class="text-center mb-2">
            <h3>{{ facturacionReport.purchased_facturas || 0 }}</h3>
            <div>Folios Adquiridos</div>
          </b-card>
        </b-col>
        <b-col md="3">
          <b-card bg-variant="light" class="text-center mb-2">
            <h3>{{ facturacionReport.used_facturas || 0 }}</h3>
            <div>Folios Utilizados</div>
          </b-card>
        </b-col>
        <b-col md="3">
          <b-card bg-variant="light" class="text-center mb-2">
            <h3>{{ facturacionReport.canceled_facturas || 0 }}</h3>
            <div>Folios Cancelados</div>
          </b-card>
        </b-col>
        <b-col md="3">
          <b-card :bg-variant="availableFacturasVariant" class="text-center mb-2">
            <h3>{{ facturacionReport.available_facturas || 0 }}</h3>
            <div>Folios Disponibles</div>
          </b-card>
        </b-col>
      </b-row>
      <b-button variant="outline-primary" size="sm" @click="getFacturacionReport">
        <b-icon icon="arrow-clockwise"></b-icon> Actualizar Reporte
      </b-button>
    </b-card>
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>Facturas Generadas</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="default" @click="$router.push('/factura')">Crear Factura</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input
              type="search"
              v-model="search"
              @keyup="page = 1"
              debounce="500"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Filtros -->
      <b-card class="mb-3" body-class="py-2">
        <b-row>
          <b-col md="3">
            <b-form-group label="Fecha desde:">
              <b-form-input type="date" v-model="filterFechaDesde" @input="onFilterChange"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Fecha hasta:">
              <b-form-input type="date" v-model="filterFechaHasta" @input="onFilterChange"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Sucursal:">
              <b-form-select v-model="filterSucursal" :options="sucursalOptions" @input="onFilterChange"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Estatus:">
              <b-form-select v-model="filterEstatus" :options="estatusOptions" @input="onFilterChange"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group label="RFC receptor:">
              <b-form-input type="search" v-model="filterRfc" debounce="400" @input="onFilterChange"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Razón social:">
              <b-form-input type="search" v-model="filterRazon" debounce="400" @input="onFilterChange"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Folio:">
              <b-form-input type="search" v-model="filterFolio" debounce="400" @input="onFilterChange"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" class="d-flex align-items-end">
            <b-form-group class="w-100">
              <b-button variant="outline-secondary" block @click="clearFilters">
                <b-icon icon="x-circle"></b-icon> Limpiar filtros
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-muted small">
          Mostrando {{ facturas.length }} de {{ totalRows }} facturas
        </div>
      </b-card>

      <b-row>
        <b-col>
          <b-table small
            striped
            hover
            :items="facturas"
            :fields="tableFields"
            responsive
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(cancelado)="data">
                                            <div v-if="data.item.cancelado">
                                                <b-icon icon="x-circle-fill" variant="danger"></b-icon> Cancelado
                                            </div>
                                            <div v-if="!data.item.cancelado">
                                                <b-icon icon="check-circle-fill" variant="success"></b-icon> Activo
                                            </div>
                                        </template>
            <template #cell(buttons)="data">
              <b-button-group >
                <b-button size="sm" variant="info" :href="'https://rigadapos-facturas.s3.us-east-2.amazonaws.com/' + data.item.uid+'.pdf'"
                  >PDF</b-button
                >
                <b-button size="sm" variant="success" :href="'https://rigadapos-facturas.s3.us-east-2.amazonaws.com/' + data.item.uid+'.xml'"
                  >XML</b-button
                >
                <b-button size="sm" variant="primary" @click="resendFacturaId=data.item.id;$refs.reenviaFactura.openModal();"
                  >Reenviar</b-button
                >
                <b-button size="sm" variant="danger"  @click="cancelFacturaId=data.item.id;$refs.cancelaFactura.openModal();"
                  >Cancelar</b-button
                >
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="byPage"
            aria-controls="my-table"
            @input="getFacturas"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
    <ReenviarFactura ref="reenviaFactura" :factura_id="resendFacturaId" ></ReenviarFactura>
    <CancelaFactura ref="cancelaFactura" :factura_id="cancelFacturaId" ></CancelaFactura>

  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import ReenviarFactura from "../components/ReenviarFactura.vue"
import CancelaFactura from "../components/CancelaFactura.vue";
export default {
  name: "facturas",
  components: { Nav, ReenviarFactura, CancelaFactura},
  watch: {
    search() {
      this.onFilterChange();
    },
  },
  data() {
    return {
      resendFacturaId: null,
      cancelFacturaId: null,
      byPage: 20,
      page: 1,
      totalRows: 0,
      sucursales: [],
      search: "",
      filterFechaDesde: "",
      filterFechaHasta: "",
      filterSucursal: null,
      filterEstatus: "todos",
      filterRfc: "",
      filterRazon: "",
      filterFolio: "",
      estatusOptions: [
        { value: "todos", text: "Todos" },
        { value: "activo", text: "Activo" },
        { value: "cancelado", text: "Cancelado" },
      ],
      facturas: [],
      facturacionReport: {
        available_facturas: 0,
        used_facturas: 0,
        purchased_facturas: 0,
        canceled_facturas: 0
      },
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "asc" },
        { key: "sucursal_id", label: "Sucursal", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "rfc_receptor", label: "RFC", sortable: true },
        { key: "razon_social_receptor", label: "Razon Social", sortable: true },
        { key: "folio", label: "Folio", sortable: true },
        { key: "version", label: "Version", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "fecha_timbrado", label: "Fecha", sortable: true },
        // { key: "status" },
        { key: "cancelado" ,label: "Cancelado", sortable: true},
        { key: "buttons" },
      ],
    };
  },
  computed: {
    availableFacturasVariant() {
      const available = this.facturacionReport.available_facturas || 0;
      if (available <= 10) return 'danger';
      if (available <= 30) return 'warning';
      return 'success';
    },
    // Sucursal dropdown options, fetched from /sucursals.
    sucursalOptions() {
      return [
        { value: null, text: "Todas" },
        ...this.sucursales.map((s) => ({
          value: s.id,
          text: s.nombre || "Sucursal " + s.id,
        })),
      ];
    },
  },
  mounted() {
    this.getFacturas();
    this.getFacturacionReport();
    this.getSucursales();
  },
  methods: {
    cleanNewUser() {
      this.newuser.name = "";
      this.newuser.password = "";
      this.newuser.email = "test@mail.com";
      this.newuser.username = "";
      this.newuser.cellphone = "5511223344";
    },
    newUser(event) {
      event.preventDefault();
      let that = this;
      axios
        .post("/user", this.newuser)
        .then(function (data) {
          that.makeToast(
            "Exito",
            data.response.username + " creado",
            "success"
          );
          that.cleanNewUser();
          that.getAllUsers();
          that.search = data.response.username;
        })
        .catch(function (err) {
          console.log(err.request.response);
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    searchGroup(id) {
      return (
        this.facturas.find((element) => element.id == id) || { name: "error" }
      );
    },
    clearFilters() {
      this.filterFechaDesde = "";
      this.filterFechaHasta = "";
      this.filterSucursal = null;
      this.filterEstatus = "todos";
      this.filterRfc = "";
      this.filterRazon = "";
      this.filterFolio = "";
      this.search = "";
      this.page = 1;
      this.getFacturas();
    },
    // Any filter change resets to the first page and refetches from the server.
    onFilterChange() {
      this.page = 1;
      this.getFacturas();
    },
    getSucursales() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          that.sucursales = response.data || [];
        })
        .catch(function () {
          // Non-blocking: the sucursal filter simply stays as "Todas".
        });
    },
    getFacturas() {
      let that = this;
      // Server-side filters + pagination via query params.
      const params = {
        page: this.page,
        per_page: this.byPage,
      };
      if (this.search) params.search = this.search;
      if (this.filterFechaDesde) params.fecha_desde = this.filterFechaDesde;
      if (this.filterFechaHasta) params.fecha_hasta = this.filterFechaHasta;
      if (this.filterSucursal !== null) params.sucursal_id = this.filterSucursal;
      if (this.filterEstatus !== "todos") params.estatus = this.filterEstatus;
      if (this.filterRfc) params.rfc = this.filterRfc;
      if (this.filterRazon) params.razon_social = this.filterRazon;
      if (this.filterFolio) params.folio = this.filterFolio;

      axios
        .get("/company/1/facturas", { params })
        .then(function (response) {
          that.facturas = response.data.data || [];
          that.totalRows = response.data.total || 0;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    getFacturacionReport() {
      let that = this;
      axios
        .get("/facturacion/report")
        .then(function (response) {
          that.facturacionReport = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error al obtener reporte de facturación", err.request?.response || "Error de conexión", "danger");
        });
    },
   
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>